<button class="gsi-material-button" (click)="onClick()">
  <div class="gsi-material-button-state"></div>
  <div class="gsi-material-button-content-wrapper">
    <div class="gsi-material-button-icon">
      <google-logo [size]="20"></google-logo>
    </div>
    <span class="gsi-material-button-contents">{{ buttonText }}</span>
    <span style="display: none;">{{ buttonText }}</span>
  </div>
</button>
